// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"campaigns-header__container___OZ8Xt","title":"campaigns-header__title___-vgCW"};
    if(module.hot) {
      // 1769992920736
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  